import { ICustomersGetResponse } from '@/shared/endpoints/customers';
import { checkHasPregnancy } from '../helpers/main';

export const ROUTES = {
    LOGIN: '/login',
    SIGN_UP: '/signup',
    CHAT: '/chat',
    CONFIRM_CODE: '/confirm-code',
    SET_PASSWORD: '/set-password',
    THANK_YOU: '/thank-you',
    ONBOARDING: {
        MAIN: 'onboarding',
        ABOUT_YOU: {
            MAIN: 'about-you',
            NAME: 'name',
            DOB_GENDER: 'dob-gender',
            ADDRESS: 'address',
            ALLERGIES_AND_CONDITIONS: 'allergies-and-conditions',
            PREGNANCY: 'pregnancy'
        },
        INSURANCE: {
            MAIN: 'insurance',
            HOME: 'home',
            ADD_WITH_IMAGE: 'add-with-image',
            ADD_MANUAL: 'add-manual'
        },
        PRESCRIPTIONS: {
            MAIN: 'prescriptions',
            MEDBOX_HUE: 'medbox-hue',
            OFTEN: 'cycle',
            MOMENT: 'take-a-moment',
            ADD: 'add-medication',
            MEDICATIONS: 'added-medications',
            MEDICATION: 'medication',
            MEDICATION_QUANTITY: 'medication-quantity',
            PRESCRIBER_AND_PHARMACY: 'prescriber-and-pharmacy'
        },
        REVIEW: 'review',
        THANK_YOU: 'thank-you'
    },
    DASHBOARD: {
        MAIN: 'dashboard',
        BILLING: {
            MAIN: 'billing',
            PAST_INVOICES: 'past-invoices/:id',
            UPCOMING_INVOICES: 'upcoming-invoices/:id'
        },
        MY_ACCOUNT: {
            MAIN: 'my-account',
            ADDRESSES: 'addresses',
            INSURANCE: 'insurance'
        },
        MY_MEDBOX: {
            MAIN: 'my-medbox',
            ACTIVE: 'active',
            PENDING: 'pending',
            ARCHIVED: 'archived',
            DRUG_INFORMATION: 'drug/:id'
        },
        SHIPMENTS: {
            MAIN: 'shipments',
            DETAILS: 'details/:id'
        },
        HOME: {
            MAIN: 'home',
            ADDRESSES: 'addresses'
        }
        // Supposed to have other sub routes
    }
};

export type NestedRoutes = {
    [key: string]: NestedRoutes | string;
} & { MAIN?: string; };

const buildGetter = (routeList: string[]) => (
    (source: NestedRoutes, key: string) => {
        if (source[key] !== null && typeof source[key] === 'object')
            return new Proxy(source[key], { get: buildGetter([...routeList, source[key].MAIN || '']) });

        if (key !== 'MAIN') routeList.push(source[key]);

        return routeList.join('/');
    }
);

export const ABSOLUTE_ROUTES = new Proxy(ROUTES, { get: buildGetter(['']) });

export const testRouteWithAttr = (step: string, attr: string, userData: ICustomersGetResponse) => {
    const routeTesters = {
        'about-you': {
            'dob-gender': () => {
                return Boolean(userData.userProfile.firstName && userData.userProfile.lastName);
            },
            address: () => {
                return Boolean(userData.userProfile.dob && userData.userProfile.gender);
            },
            'allergies-and-conditions': () => {
                return userData.addresses.length;
            },
            pregnancy: () => {
                // check if user fill allergies and can have pregnancy
                return Boolean(
                    Array.isArray(userData.userProfile?.allergies) &&
                        Array.isArray(userData.userProfile?.conditions) &&
                        userData.userProfile.dob &&
                        checkHasPregnancy(userData.userProfile)
                );
            }
        },
        prescriptions: {
            cycle: () => {
                return userData.userOnboarding?.details?.medboxHueType !== undefined;
            },
            'take-a-moment': () => {
                return userData.userOnboarding?.details?.cycleDuration !== undefined;
            },
            'added-medications': () => {
                return userData?.transferPrescriptions?.length;
            },
            'add-medication': () => {
                return userData.userOnboarding?.details?.cycleDuration !== undefined;
            }
        }
    };

    return routeTesters[step]?.[attr]?.() ?? true;
};

export const pagesHasFooter = [ROUTES.DASHBOARD.HOME.MAIN, ROUTES.DASHBOARD.HOME.ADDRESSES];
